import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Text,
  Flex,
  theme,
  useMediaQuery,
  Tooltip,
} from "@chakra-ui/react";
import Thread from "components/tweets/masonry/thread";
import { cancelPostPublishActions } from "controllers/schedule";
import { DialogBox } from "components/collaboration/dialog-box";
import { hasAdvancedOptions } from "utils/tweetUtils";
import { ModalInfoIcon } from "components/popups/ModalInfoIcon";
import { textStyle } from "theme/names";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  tweet: any;
  hideAdvancedButton?: boolean;
  isGhostwriter: boolean;
  showAddToQueue: boolean;
  handleAddToQueue: () => void;
}

export function SettingsPopup({ isOpen, onClose, tweet, hideAdvancedButton = false,
  isGhostwriter = false,
  showAddToQueue = false,
  handleAddToQueue = () => { },
}: Props) {
  const [isCancelling, setIsCancelling] = useState<boolean>(false);
  const [isTooSmall] = useMediaQuery("(max-width: 1000px)");
  const threadTweets = [tweet.text];
  const [activeAdvancedOptions] = hasAdvancedOptions(tweet);


  let cssBody = {
    p: 6,
    position: "relative",
    // chin of the modal part 1
    _before: {
      content: "''",
      position: "absolute",
      bottom: "-4px",
      left: "0",
      width: "100%",
      height: "16px",
      borderBottomRadius: "10px",
      background: "primary.lightMode.default",
    },
    // chin of the modal part 2
    _after: {
      content: "''",
      position: "absolute",
      bottom: "0px",
      left: "0",
      width: "100%",
      height: "16px",
      borderBottomRadius: "10px",
      background: "white",
    },
    _dark: {
      background: "#1E1E1E",
      border: "1px solid",
      borderColor: "border.darkMode.light", // dark mode

      _after: {
        background: "#1E1E1E",
      },
    },
  };

  let enableCollaboration = !!tweet.ghostwriterId && !isTooSmall;
  let collaborationWidth = 448;

  // console.log('tweet:', tweet)

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent mr={enableCollaboration ? collaborationWidth + 50 : 0} pb="3">
        <ModalHeader>
          {/* <ModalInfoIcon /> */}
          Your post
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {threadTweets && (
            <Box display="flex" justifyContent="center" position="relative">
              <Thread
                maxW="670px"
                threadTweets={threadTweets}
                disableNbChar={true}
                tweet={tweet}
                showOutline={true}
                showGenerateImage={false}
              />
              {!isTooSmall && tweet?.text?.match(/r\n|\r|\n/g)?.length > 4 && (
                <Flex
                  w="100%"
                  px="30px"
                  position="absolute"
                  right="0px"
                  top="140px"
                  flexDir="column"
                  alignItems="flex-end"
                >
                  {/* <Text textStyle={textStyle["body.medium.light"]} fontSize="xs">Read more</Text> */}
                  <Tooltip label="Read more limit">
                    <Box
                      border={"dashed 1px " + theme.colors.gray[300]}
                      w="100%"
                      h="1px"
                    ></Box>
                  </Tooltip>
                </Flex>
              )}
            </Box>
          )}
          {
            isTooSmall && tweet.ghostwriterId && (
              <Box mt={0} bg={"white"} p={5} rounded="md" w={"100%"}>
                <DialogBox tweet={tweet} isGhostwriter={isGhostwriter} onClose={onClose} />
              </Box>
            )
          }
        </ModalBody>

        {
          tweet.ghostwriterId && !isTooSmall && (
            // <Box position="absolute" left="900px" top={5} bg={"white"} p={5} rounded="md" w={collaborationWidth} zIndex={1400}>
            <Box {...cssBody} mt={1} position="fixed" left="calc(50vw + 20px)" top={"60px"} bg={"white"} p={5} rounded="md" w={collaborationWidth} zIndex={1500}>
              <DialogBox tweet={tweet} isGhostwriter={isGhostwriter} onClose={onClose} />
            </Box>
          )
        }
        {!hideAdvancedButton && activeAdvancedOptions && (
          <ModalFooter justifyContent="center">
            <Button
              variant="primaryDestructive"
              onClick={async () => {
                setIsCancelling(true);
                await cancelPostPublishActions(tweet);
                setIsCancelling(false);
                onClose();
              }}
              isLoading={isCancelling}
            >
              Cancel all advanced options
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
}
